import { render, staticRenderFns } from "./ResetMDP.vue?vue&type=template&id=b50c9412"
import script from "./ResetMDP.vue?vue&type=script&lang=js"
export * from "./ResetMDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports